/* eslint-disable @next/next/no-img-element */
import {Editor} from '@tinymce/tinymce-react';
import {useState, useRef, useEffect} from "react";
import {Button, Modal} from "react-bootstrap";
import {useForm} from "react-hook-form";
import http from 'utilities/http';
import {getCookie} from 'framework/libs/cookie';
import {TOKEN_CONGDONG} from 'framework/store/constants';
import {toast} from 'react-toastify';
import {API_URL_V2} from 'utilities/constants';
import {isEmpty} from "lodash";

export default function EditorComponent({ displayModalP, setDisplayModalP, imageSelectP, setImageSelectP, isSingleSelect = false}) {
    const [imageDisplay, setImageDisplay] = useState([]);
    const [imageUpload, setImageUpload] = useState([]);
    const {register, handleSubmit} = useForm();

    const [next, setNext] = useState(0);

    const onHideModal = () => {
        setDisplayModalP(false);
    };

    const fetchMyImage = async (page) => {
        const res = await http(`community/my-files?per_page=20&page=${page}`, {}, {token: 'Bearer ' + getCookie(TOKEN_CONGDONG)}, 'v2');
        if (res.success == true) {
            if (isEmpty(res.data)) return;
            res.data.forEach(img => img.select = false);
            if (page === 1) {
                setImageDisplay(res.data);
            } else {
                setImageDisplay(imageDisplay.concat(res.data));
            }
            setNext(res.meta?.pagination.current_page < res.meta?.pagination.total_pages ? res.meta?.pagination.current_page + 1 : 0);
        }
    };

    useEffect(() => {
        fetchMyImage(1);
    }, []);

    const selectImage = (image) => {
        let indexSelect = -1;
        const isSelected = imageSelectP.some((x, index) => {
            if (x.id === image.id) {
                indexSelect = index;
                return true;
            }
            return false;
        });

        if (isSelected) {
            setImageSelectP(!isSingleSelect ? imageSelectP.filter(x => x.id !== image.id) : []);
        } else {
            setImageSelectP(!isSingleSelect ? imageSelectP.concat(image) : [image]);
        }
    };

    const uploadFile = async (event) => {
        const formData = new FormData();
        Array.from(imageUpload).forEach(img => {
            formData.append('files[]', img);
        });

        try {
            const res = await fetch(API_URL_V2 + 'community/file/upload-files', {
                body: formData,
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG)
                })
            });
            const json = await res.json();

            if (json.success) {
                setImageUpload([]);
                setImageSelectP(!isSingleSelect ? imageSelectP.concat(json.data) : json.data);
                await fetchMyImage(1);
            } else {
                toast.error(json.errors || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        } catch (e) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại!');
        }
    };
    const uploadFromLocal = async (e) => {
        if (e.target.files.length !== 0) {
            setImageUpload(e.target.files);
        }
    };
    useEffect(() => {
        if (imageUpload.length === 0) return;
        handleSubmit(uploadFile)();
    }, [imageUpload]);

    return <Modal backdrop={true} show={displayModalP} onHide={onHideModal} role="document"
        className="modal-choose-photo">
        <Modal.Header closeButton>
            <h5 className="modal-title">Chọn Ảnh</h5>
        </Modal.Header>
        <Modal.Body>
            <div className="choosePhoto">
                <ul>
                    {
                        imageDisplay.map((image, index) => {
                            return (
                                <li key={index}>
                                    <div
                                        className={imageSelectP.some(x => x.id === image.id) ? "choosePhoto-thumb wrap-next-image choosePhoto-thumb--check" : "choosePhoto-thumb wrap-next-image"}
                                        style={{width: 111, height: 111}}
                                        onClick={() => selectImage(image)}
                                    >
                                        <img src={image.storage_thumbnail_url || image.storage_url} alt=""/>
                                        <span className="choosePhoto-select"></span>
                                    </div>
                                </li>);
                        })
                    }
                    {next > 0 && <li>
                        <div className={"choosePhoto-thumb wrap-next-image "} style={{width: 111, height: 111}}
                            onClick={() => fetchMyImage(next)}>
                            <div className="text-center" style={{fontSize: 20}}>...</div>
                        </div>
                    </li>}
                </ul>
            </div>
            <ul className="btn-footer">
                <li>
                    <form onSubmit={handleSubmit(uploadFile)} id="image-form">
                        <label className="custom-control custom-file pl-0">
                            <span className="btn btn--blueWhite">
                                <input {...register('files')} multiple className="custom-file-input" type="file"
                                    onChange={uploadFromLocal}/>
                                Tải ảnh từ thiết bị
                            </span>
                        </label>
                    </form>
                </li>
                <li>
                    <button className="btn btn--blue" onClick={onHideModal}>Xong</button>
                </li>
            </ul>
        </Modal.Body>
    </Modal>;
}
